export default __webpack_public_path__ + "static/media/white-room.48d8ab46.mp4";